import makeCall, { host } from '../services/api'
const mediaUrl = host + '/open/media/a1Api/images/view/'

export const galleryImageInterface = (i) => ({ 
    ...i,
    url: mediaUrl + i.image,
    thumb: mediaUrl + i.thumb,
    image: mediaUrl + i.image,
    tags: i.tags ? JSON.parse(i.tags) : [],
    showInGallery: i.showInGallery === true || i.showInGallery.toLower
})

export default {
    state: {
        splash: { 
            image: null,
            loaded: false
        },
        gallery: {
            loaded: false,
            data: []
        },
        services: {
            loaded: false,
            data: []
        },
        objects: {
            loaded: false,
            data: []
        }
    },
    mutations: {
        clearEditSiteState (state) {
            state.splash = { 
                image: null,
                loaded: false
            }
            state.gallery = {
                loaded: false,
                data: []
            }
            state.services = {
                loaded: false,
                data: []
            }
            state.objects = {
                loaded: false,
                data: []
            }
        },
        updateObjectsList (state, payload) {
            state.objects = {
                loaded: true,
                data: payload
            }
        },
        updateServicesList (state, payload) {
            state.services = {
                loaded: true,
                data: payload
            }
        },
        updateSplashImage (state, payload) {
            state.splash = payload
        },
        replaceGalleryImages (state, payload) {
            state.gallery = {
                loaded: true,
                data: [...payload]
            }
        },
        updateGalleryImages (state, payload) {
            state.gallery = {
                loaded: true,
                data: [...payload].map(i => galleryImageInterface(i))
            }
        }
    },
    actions: {
        // IMAGES CRUD
        async loadSplashImage ({ commit }) {
            const result = await makeCall({ url: '/images/get-splash/' })
            return commit('updateSplashImage', { loaded: true, image: result.data + '?ts=' + Date.now() })
        },
        async updateSplashImage ({ state, commit }, payload) {
            const formData = new FormData()
            formData.append('file', payload)            
            const response = await makeCall({
              url: '/images/splash/', 
              method: 'PATCH',
              requestType: 'form',
              body: formData
            })
            const useImageData = (response && response.data) || state.splash.image.split('?ts')[0]
            commit('updateSplashImage', null)
            return commit('updateSplashImage', { loaded: true, image: useImageData + '?ts=' + Date.now() })
        },
        async restoreSplashImage ({state, commit}) {         
            await makeCall({ url: '/images/restore-splash/' })
            const oldImage = state.splash.image.split('?ts')[0]
            commit('updateSplashImage', null)
            return commit('updateSplashImage', { loaded: true, image: oldImage + '?ts=' + Date.now() })
        },
        async loadGalleryImages ({commit}) {
            const response = await makeCall({ url: '/images/all-gallery/' })
            if (response && response.data) {
                commit('updateGalleryImages', response.data)
            }
        },
        async deleteGalleryImage({state, commit}, payload) {
            const result = await makeCall({ 
                url: `/images/${payload}/`,
                method: 'DELETE'
             })
             if (result && result.success) {
                commit('replaceGalleryImages', [...state.gallery.data].filter(i => i.id !== payload))
             }
             return result
        },
        async handleSaveGalleryUpdate({state, commit}, payload) {
            const body = {...payload}
            if (body.tags) {
                body.tags = JSON.stringify(body.tags)
            }
            const result = await makeCall({ 
                url: `/images/gallery/`,
                method: 'PATCH',
                body
             })
             if (result && result.success) {
                commit('replaceGalleryImages', [...state.gallery.data].map(i => {
                    return i.id === payload.id ? { ...i, ...payload } : { ...i }
                }))
             }
            return result
        },
        async uploadGalleryImage({commit, state}, payload) {
            const formData = new FormData()
            formData.append('file', payload.image)
            formData.append('title', payload.title)
            if(payload.category && payload.category !== '') {
                formData.append('category', payload.category) 
            }
            if (payload.tags) {
                formData.append('tags', JSON.stringify(payload.tags))
            }
            formData.append('featured', payload.featured) 
            formData.append('showInGallery', payload.showInGallery)        
            const resp = await makeCall({
                  url: '/images/gallery/', 
                  method: 'POST',
                  requestType: 'form',
                  body: formData
            })
            if (resp && resp.success) {
                commit('replaceGalleryImages', [
                    ...state.gallery.data,
                    galleryImageInterface(resp.data)
                ])
            }
            return resp
        },
        // SERVICES CRUD
        async getServicesList ({commit}) {
            const user = this.getters.user
            const response = await makeCall({ url: `/site/resources/services-list/${user && user.resourceid}/` })
            if (response && response.data && response.data.length > 0) {
                commit('updateServicesList', response.data)
            }
        },
        async deleteServiceItem ({state, commit}, payload) {
            await makeCall({ url: `/services/${payload}/`, method: 'DELETE' })
            const servicesListCopy = [ ...state.services.data ].filter(s => s.id !== payload)
            return commit('updateServicesList', servicesListCopy)
        },
        async addServiceItem ({state, commit}, payload) {
            const resp = await makeCall({ url: `/services/new/`, method: 'POST', body: payload })
            const newItem = { ...payload, id: resp.data.id }
            const servicesListCopy = [ ...state.services.data, newItem ]
            return commit('updateServicesList', servicesListCopy)
        },
        async updateServiceItem ({ state, commit }, payload) {
            await makeCall({ url: `/services/${payload.id}/`, method: 'PATCH', body: payload })
            const servicesListCopy = [ ...state.services.data ].map(s => {
                if (s.id === payload.id) return {...payload}
                return s
            })
            return commit('updateServicesList', servicesListCopy)
        },
        // Objects crud
        async addObject ({state, commit}, payload) {
            const resp = await makeCall({ url: `/objects/new/`, method: 'POST', body: payload })
            const newItem = { ...payload, id: resp.data.id }
            const objectItemCopy = [ ...state.objects.data, newItem ]
            return commit('updateObjectsList', objectItemCopy)
        },
        async loadObjects ({ commit }) {
            const user = this.getters.user
            const response = await makeCall({ url: `/site/resources/objects-list/${user && user.resourceid}/` })
            if (response && response.data && response.data.length > 0) {
                return commit('updateObjectsList', response.data)
            }
        },
        async deleteObject ({ commit, state }, payload) {
            await makeCall({ url: `/objects/${payload}/`, method: 'DELETE' })
            const objectListCopy = [ ...state.objects.data ].filter(o => o.id !== payload)
            return commit('updateObjectsList', objectListCopy)
        },
        async updateObject ({ state, commit }, payload) {
            await makeCall({ url: `/objects/${payload.id}/`, method: 'PATCH', body: payload })
            const objectListCopy = [ ...state.objects.data ].map(s => {
                if (s.id === payload.id) return { ...payload }
                return s
            })
            return commit('updateObjectsList', objectListCopy)
        },
    },
    getters: {
        splash (state) { 
            return state.splash && state.splash.image ? mediaUrl + state.splash.image : null
        },
        splashLoaded (state) {
            return state.splash && state.splash.loaded
        }, 
        services (state) { return state.services },
        gallery (state) { return state.gallery },
        objects (state) { return state.objects }
    }
}